import Enumerable from "linq";
import { RecipientTypeEnum } from "../../../../common/enums/RecipientTypeEnum";
import { IAlarmNotificationCountModel } from "../../../../services/alarm-data-service/Models";
import { GraphItemOptions } from "../../../../services/trending-data-service/Models";
import { Options, SeriesOptionsType, } from "highcharts";
import GraphUtils from "../../../../common/utilities/GraphUtils";
import { format } from "date-fns";
import { getTimeframeTimeDisplayText } from "../../../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../../../common/enums/TimeframeTypeEnum";

const chartColors = [
    "#2ac8b4",
    "#767676",
    "#fe6d73",
    "#fee890",
    "#227c9d"
];

const NotificationsCountsGraphUtils = {

    getChartOptions: function(
        durationDays: number,
        notificationCounts: IAlarmNotificationCountModel[],
        showText: boolean,
        showEmail: boolean,
        showVoice: boolean,
    ): GraphItemOptions {


        const data = showText && showEmail && showVoice ?
                        notificationCounts :
                        notificationCounts.filter(o => (o.recipientType === RecipientTypeEnum.Text && showText) ||
                                                        (o.recipientType === RecipientTypeEnum.Voice && showVoice) ||
                                                        (o.recipientType === RecipientTypeEnum.Email && showEmail));
    
        let groupedData = Enumerable.from(data)
                        .where(o => o.recipientType === RecipientTypeEnum.Text)
                        .groupBy(o => new Date(o.alarmTimestamp));


    let shapedData = groupedData
        .select(o => {
            const item = {
                alarmTimestamp: o.key(),
                count: o.sum(x => x.count)
            };

            return item;
        })
        .toArray();

    const textSeriesData = Enumerable.from(shapedData).select(o => {
        return [o.alarmTimestamp.getTime(), o.count]
    }).toArray();


    groupedData = Enumerable.from(data)
        .where(o => o.recipientType === RecipientTypeEnum.Email)
        .groupBy(o => new Date(o.alarmTimestamp));


    shapedData = groupedData
        .select(o => {
            const item = {
                alarmTimestamp: o.key(),
                count: o.sum(x => x.count)
            };

            return item;
        })
        .toArray();

    const emailSeriesData = showEmail ? Enumerable.from(shapedData).select(o => {
        return [o.alarmTimestamp.getTime(), o.count]
    }).toArray() : [];

    groupedData = Enumerable.from(data)
        .where(o => o.recipientType === RecipientTypeEnum.Voice)
        .groupBy(o => new Date(o.alarmTimestamp));


    shapedData = groupedData
        .select(o => {
            const item = {
                alarmTimestamp: o.key(),
                count: o.sum(x => x.count)
            };

            return item;
        })
        .toArray();

    const voiceSeriesData = showVoice ? Enumerable.from(shapedData).select(o => {
        return [o.alarmTimestamp.getTime(), o.count]
    }).toArray() : [];


    const pill = 'display: inline-block;width: 1.3rem; text-align: center; font-size: .7rem; xcolor: #fff; border: 1px solid #536580; cursor: auto; height: .7rem; line-height: .8rem; vertical-align: middle; border-radius: 8px;';

    const seriesData: SeriesOptionsType[] = [];

    if (showText) {

        seriesData.push({

            name: `<span><span style="${pill}background-color:${chartColors[0]}; border-color:${chartColors[0]};"></span> Text</span>`,
            type: 'line',
            data: textSeriesData,
            color: chartColors[0],
            lineWidth: 2
        });
    }

    if (showEmail) {
        seriesData.push({
            name: `<span><span style="${pill}background-color:${chartColors[1]}; border-color:${chartColors[1]};"></span> Email</span>`,
            type: 'line',
            data: emailSeriesData,
            color: chartColors[1],
            lineWidth: 2
        });
    }
    // const seriesData: SeriesOptionsType[] = [{

    //     name: `<span><span style="${pill}background-color:${chartColors[0]}; border-color:${chartColors[0]};"></span> Text</span>`,
    //     type: 'line',
    //     data: textSeriesData,
    //     color: chartColors[0],
    //     lineWidth: 2
    // }, {
    //         name: `<span><span style="${pill}background-color:${chartColors[1]}; border-color:${chartColors[1]};"></span> Email</span>`,
    //         type: 'line',
    //         data: emailSeriesData,
    //         color: chartColors[1],
    //         lineWidth: 2
    // }];

    if (showVoice) {

        seriesData.push({
            name: `<span><span style="${pill}background-color:${chartColors[2]}; border-color:${chartColors[2]};"></span> Voice</span>`,
            type: 'line',
            data: voiceSeriesData,
            color: chartColors[2],
            lineWidth: 2
        });
    }

    const options: Options = {
        chart: {
            type: 'line',
            zooming: {
                type: 'x'
            }

        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        title: {
            text: 'NOTIFICATIONS BY TYPE',
            align: "left",
            style: {
                fontSize: ".95rem"
            }
        },
        xAxis: [{
            type: "datetime",
            labels: {
                useHTML: true,
                formatter: function () {
                    return durationDays === 1 ? 
                                format(new Date(this.value), 'MM/dd KK:mm a') : 
                                format(new Date(this.value), 'MM/dd/y')
                },
                staggerLines: 2,
                overflow: "justify"
            },
            //tickInterval: durationDays === 1 ? undefined : 24 * 60
        }],
        yAxis: [{
            title: {
                text: 'Notifications'
            },
            
        }],
        tooltip: {
            formatter: function () {
                //return `<b>${this.y}</b> Notifications<br />${format(new Date(this.x as number), 'LLL dd, KK:mm a')}`; 
                return `<b>${this.y}</b> Notifications<br />${getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date(this.x as number))}`; 
            }
        },
        plotOptions: {
            area: {
                marker: {
                    enabled: false,
                    symbol: 'circle',
                    radius: 2,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                }
            }
        },
        series: seriesData,
        legend: {
            enabled: true,
            useHTML: true,
            // hide the symbols since we have custom symbols to display
            symbolWidth: 0,
            symbolRadius: 0,
            itemStyle: {
                fontSize: ".8em",
                color: "#536580",
                fontWeight: "normal"
            }
        }
    };
                                            
        return  {...options,
                headerTitle: "notification counts",
                id: GraphUtils.getChartID(),
                index: 0,
                
            }
    }
}

export default NotificationsCountsGraphUtils;